import React, { useState, useContext, useCallback } from "react";
import { Grid, Row, Col, message } from "antd";
import { useHistory } from "react-router-dom";
import AppLayout from "../components/AppLayout";
import styles from "./Landing.module.css";
import { MetaMaskContext } from "../components/MetaMaskSDKContainer";

const { useBreakpoint } = Grid;

const Landing = () => {
  const breakpoint = useBreakpoint();
  const history = useHistory();
  const { connect: connectMetaMask, requestSwitchChain } =
    useContext(MetaMaskContext);

  const [isLoading, setIsLoading] = useState(false);

  const connect = useCallback(async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    try {
      const connectedAddress = await connectMetaMask();
      const requestSuccess = await requestSwitchChain();

      if (!connectedAddress || !requestSuccess) {
        return;
      }

      window.localStorage.setItem("wallet_address", connectedAddress);
      history.push("/storing");
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [isLoading, history, connectMetaMask, requestSwitchChain]);

  return (
    <AppLayout>
      <div className="boxContainer">
        <div className={styles.landingContainer}>
          <Row gutter={[12]} justify="center">
            <Col>
              <img
                src="/images/landing/star.png"
                style={{ width: 32, height: 32 }}
                alt=""
              />
            </Col>
            <Col className={styles.ft_32_600}>Sweat & Earn</Col>
            <Col>
              <img
                src="/images/landing/star.png"
                style={{ width: 32, height: 32 }}
                alt=""
              />
            </Col>
          </Row>

          <Row
            justify="center"
            className={styles.ft_44_900}
            style={{ marginTop: 16 }}
          >
            Together: we build the future of wellness
          </Row>

          <Row
            justify="center"
            gutter={[breakpoint?.md ? 70 : 30]}
            style={{ marginTop: 24, flexWrap: "nowrap" }}
          >
            <Col>
              <Row justify="center">
                <img
                  src="/images/landing/connect.png"
                  style={{ width: 40, height: 40 }}
                  alt=""
                />
              </Row>
              <Row
                className={styles.ft_16_600}
                style={{ maxWidth: breakpoint?.md ? 145 : 120, textAlign: "center", marginTop: 16 }}
              >
                Connect with your wallet
              </Row>
            </Col>

            <Col style={{ position: "absolute" }}>
              <img
                src={`/images/landing/line${breakpoint?.md ? "" : "_mobile"}.png`}
                style={{ width: breakpoint?.md ? 120 : 80, height: 2, marginTop: 20 }}
                alt=""
              />
            </Col>

            <Col>
              <Row justify="center">
                <img
                  src="/images/landing/farming.png"
                  style={{ width: 40, height: 40 }}
                  alt=""
                />
              </Row>
              <Row
                className={styles.ft_16_600}
                style={{ maxWidth: breakpoint?.md ? 145 : 120, textAlign: "center", marginTop: 16 }}
              >
                Start missions to earn EXP
              </Row>
            </Col>
          </Row>

          <Row
            justify="center"
            style={{ marginTop: 40, padding: breakpoint?.md ? "" : "0px 20px" }}
          >
            <div
              className={styles.button}
              onClick={() => {
                connect();
              }}
            >
              <Row align="middle">
                <Col className={styles.buttonText}>Connect Wallet</Col>
                <Col style={{ display: "flex", placeContent: "center" }}>
                  <img
                    src="/images/landing/Wallet.png"
                    style={{ width: 20, height: 20, marginLeft: 12 }}
                    alt=""
                  />
                </Col>
              </Row>
            </div>
          </Row>
        </div>
      </div>
    </AppLayout>
  );
};

export default Landing;
